<div class="rto-details-container">
  <div class="rto-container">
    <div class="navigation-breadcrumb">
      <span class="breadcrumb-text" (click)="goToDashboard()">{{
        RTO_DETAILS_CONFIG.Dashboard
      }}</span>
    </div>

    <div class="rto-circles-container">
      <div class="rto-circle" *ngFor="let item of rtoLegendItems">
        <div class="circle" [ngClass]="item?.colorClass"></div>
        <span class="label">{{ item?.label }}</span>
      </div>
    </div>
  </div>

  <div class="rto-search-table-container">
    <div class="rto-details-search" [ngClass]="{ 'show-custom-range': showCustomDateRange }">
      <div class="rto-title">
        <span>{{ RTO_DETAILS_CONFIG.Information }}</span>
      </div>
      <div class="search-bar-container">
        <div class="search-child">
          <emerald-input
            [label]="'Search'"
            [trailingIcon]="'search'"
            (keyup)="searchContractors($event)"
            [value]="filterValue"
            ><emerald-icon
              *ngIf="filterValue?.length && filterValue.length > 0"
              [icon]="'close'"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
         <emerald-dropdown
          *ngIf="directIndirectReporteeOptions.length > 0"
          [options]="directIndirectReporteeOptions"
          [outlined]="true"
          [id]="'single_select'"
          [label]="'Teams'"
          [preSelectedValue]="selectedEmployee"
          (onChangeValue)="onReporteesChange($event)"
        ></emerald-dropdown>
         <emerald-dropdown
          [options]="monthOptions"
          [outlined]="true"
          [id]="'month_select'"
          [label]="'Month'"
          [value]="selectedOption"
          (onChangeValue)="onMonthChange($event)"
        ></emerald-dropdown>
        <div class="date-range"
          *ngIf="showCustomDateRange">
          <app-date-range
            [dateLabel]="dateLabel"
            [startDatePlaceholder]="startDatePlaceholder"
            [endDatePlaceholder]="endDatePlaceholder"
            [cardComponent]="'RTO_DETAILS'"
            [maxDateRangeInYears]="2"
            (dateRangeSelected)="handleDateRangeChange($event)"
          >
          </app-date-range>
        </div>
        <app-button-group
          [label]="'Download'"
          [icon]="'download'"
          [buttonType]="'Secondary'"
          [cssClass]="'bordered-bg'"
          [buttonUseCase]="'export'"
          (onEmit)="handleExport()"
        >
        </app-button-group>
        <emerald-button
          [label]="'Add Exception'"
          [type]="'Secondary'"
          [size]="'Medium'"
          (click)="openAddExceptionModal()"
        >
        </emerald-button>
      </div>
    </div>

    <!-- Months multi-select: full-width bar below the filter row so the
         chips never crowd the search controls -->
    <div class="months-picker-bar" *ngIf="showMonthsPicker">
      <div class="months-picker-bar__row">
        <label class="months-year-label" for="rto-months-year">Year</label>
        <select
          id="rto-months-year"
          class="months-year-select"
          (change)="onMonthsYearChange($any($event.target).value)"
        >
          <option
            *ngFor="let y of monthsYearOptions"
            [value]="y.value"
            [selected]="y.value === '' + selectedMonthsYear"
          >{{ y.label }}</option>
        </select>
        <div class="month-chips">
          <button
            type="button"
            class="month-chip"
            *ngFor="let chip of monthChips"
            [class.month-chip--selected]="isMonthSelected(chip.month)"
            [class.month-chip--disabled]="chip.disabled"
            [disabled]="chip.disabled"
            (click)="toggleMonthChip(chip)"
          >
            {{ chip.label }}
          </button>
        </div>
        <div class="months-picker-bar__actions">
          <emerald-button
            [label]="'Apply'"
            [type]="'Primary'"
            [size]="'Medium'"
            (click)="applyMonthsFilter()"
          ></emerald-button>
          <emerald-button
            *ngIf="selectedMonths.size > 0"
            [label]="'Clear'"
            [type]="'Secondary'"
            [size]="'Medium'"
            (click)="clearMonthsFilter()"
          ></emerald-button>
        </div>
      </div>
      <div class="months-picker-summary" *ngIf="selectedMonths.size > 0">
        Selected: {{ selectedMonthsLabel }}
      </div>
    </div>

    <div class="rto-details-table">
      <ng-container *ngIf="displayData?.length; else noDataTemplate">
        <emerald-datatable
          [columnDefs]="columnDefs"
          [rowData]="displayData"
          [paginationParams]="paginationParams"
          (onRowSelect)="onRowSelected($event)"
          [customCellTemplate]="{
            status: customStatusColumn,
            resource: customResourceNameColumn,
            rtoPercentage: customRtoPercentageColumn,
            officeDays: customOfficeDaysColumn,
          }"
        >
        </emerald-datatable>
      </ng-container>
      <ng-template #noDataTemplate>
        <section class="records-container" aria-label="Records section">
          <div class="empty-state">
            <ng-container *ngIf="isDataLoaded">
              <h2 class="empty-state-title">{{ errorMsg }}</h2>
            </ng-container>
            <img
              [src]="imageSrc"
              alt="{{ errorMsg }}"
              class="empty-state-image"
            />
          </div>
        </section>
      </ng-template>

      <ng-template #customStatusColumn let-level="level" let-eachRow="eachRow">
        <div class="status-container">
          <span [class]="'status-chip ' + getStatusClass(eachRow?.status)">
            {{ eachRow.status }}
          </span>
          <div class="comment-section" *ngIf="eachRow?.exceptionList?.length">
            <emerald-tooltip
              [placement]="'bottom'"
              [trigger]="'hover'"
              [content]="getTooltipContent(eachRow)"
            >
              <div class="comment-trigger" emeraldTooltipTrigger>
                <emerald-icon
                  [type]="'outlined'"
                  [icon]="'visibility'"
                  [fontsizeInRem]="RTO_DETAILS_CONFIG.Font_Size"
                  class="comment-icon"
                >
                </emerald-icon>
                <span class="comment-text">{{
                  RTO_DETAILS_CONFIG.Comment
                }}</span>
              </div>
            </emerald-tooltip>
          </div>
        </div>
      </ng-template>
      <ng-template
        #customResourceNameColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <div class="resource-container">
          <div class="employee-name">
            <!-- opens the RTO drill-down panel (month-wise days + exact
                 dates), not the 360 profile -->
            <a
              (click)="openRtoDrill(eachRow)"
              class="employee-link"
              title="View month-wise RTO attendance"
              >{{ eachRow?.name }}</a
            >
          </div>
          <div class="employee-role">
            {{ eachRow?.empId }} | {{ eachRow?.jobTitle }}
          </div>
        </div>
      </ng-template>
      <ng-template
        #customRtoPercentageColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        {{ eachRow?.rtoPercentage }}%
      </ng-template>
      <ng-template
        #customOfficeDaysColumn
        let-level="level"
        let-eachRow="eachRow"
      >
        <button
          type="button"
          class="office-days-link"
          title="View month-wise attendance and exact dates"
          (click)="openRtoDrill(eachRow)"
        >
          {{ eachRow?.officeDays }}
          <emerald-icon
            [type]="'outlined'"
            [icon]="'calendar_month'"
            [fontsizeInRem]="RTO_DETAILS_CONFIG.Font_Size"
          ></emerald-icon>
        </button>
      </ng-template>
    </div>
  </div>
</div>

<!-- ── RTO day drill-down slide-over ── -->
<div class="rto-drill-overlay" *ngIf="showRtoDrill" (click)="closeRtoDrill()"></div>
<aside class="rto-drill-panel" *ngIf="showRtoDrill" aria-label="RTO attendance breakdown">
  <header class="rto-drill-header">
    <div>
      <h3 class="rto-drill-name">{{ drillEmployee?.name }}</h3>
      <div class="rto-drill-sub">
        {{ drillEmployee?.empId }} | {{ drillEmployee?.jobTitle }}
      </div>
      <div class="rto-drill-period" *ngIf="!drillLoading">
        {{ drillTotalDays }} office day{{ drillTotalDays === 1 ? '' : 's' }}
        across {{ drillMonths.length }} month{{ drillMonths.length === 1 ? '' : 's' }}
      </div>
    </div>
    <button type="button" class="rto-drill-close" (click)="closeRtoDrill()" aria-label="Close">
      <emerald-icon [icon]="'close'"></emerald-icon>
    </button>
  </header>

  <!-- in-panel period controls: change this person's window without
       touching the table's filter -->
  <div class="rto-drill-period-picker">
    <select
      class="months-year-select"
      aria-label="Year"
      (change)="onDrillYearChange($any($event.target).value)"
    >
      <option
        *ngFor="let y of monthsYearOptions"
        [value]="y.value"
        [selected]="y.value === '' + drillYear"
      >{{ y.label }}</option>
    </select>
    <div class="month-chips month-chips--compact">
      <button
        type="button"
        class="month-chip"
        *ngFor="let chip of drillMonthChips"
        [class.month-chip--selected]="isDrillMonthSelected(chip.month)"
        [class.month-chip--disabled]="chip.disabled"
        [disabled]="chip.disabled"
        (click)="toggleDrillChip(chip)"
      >
        {{ chip.label }}
      </button>
    </div>
    <button type="button" class="rto-drill-apply" (click)="applyDrillPeriod()">
      Apply
    </button>
  </div>

  <div class="rto-drill-body">
    <div class="rto-drill-loading" *ngIf="drillLoading">Loading attendance…</div>

    <div class="rto-drill-empty" *ngIf="!drillLoading && drillMonths.length === 0">
      No attendance records in the selected period.
    </div>

    <div class="rto-drill-month" *ngFor="let m of drillMonths">
      <button
        type="button"
        class="rto-drill-month-row"
        (click)="toggleDrillMonth(m.month)"
        [attr.aria-expanded]="expandedDrillMonth === m.month"
      >
        <span class="rto-drill-month-label">{{ m.label }}</span>
        <span class="rto-drill-month-bar">
          <span class="rto-drill-month-fill" [style.width.%]="monthBarPct(m)"></span>
        </span>
        <span class="rto-drill-month-count">
          {{ m.officeDays }} day{{ m.officeDays === 1 ? '' : 's' }}
          <span class="rto-drill-month-working" *ngIf="m.workingDays > 0">
            / {{ m.workingDays | number: '1.0-0' }} working
          </span>
        </span>
        <span class="rto-drill-month-caret">
          {{ expandedDrillMonth === m.month ? '▾' : '▸' }}
        </span>
      </button>

      <div class="rto-drill-calendar" *ngIf="expandedDrillMonth === m.month">
        <div class="rto-cal-head">
          <span class="rto-cal-cell" *ngFor="let wd of weekdayHeaders">{{ wd }}</span>
        </div>
        <div class="rto-cal-week" *ngFor="let week of calendarWeeks(m)">
          <span
            class="rto-cal-cell"
            *ngFor="let cell of week"
            [class.rto-cal-cell--attended]="cell.attended"
            [class.rto-cal-cell--empty]="cell.day === null"
            [title]="cell.attended ? 'In office' : ''"
          >{{ cell.day ?? '' }}</span>
        </div>
        <div class="rto-drill-dates" *ngIf="m.dates.length">
          <span class="rto-drill-dates-label">Dates:</span>
          {{ m.dates.join(', ') }}
        </div>
      </div>
    </div>
  </div>
</aside>
<app-add-exception
  *ngIf="showAddExceptionModal"
  [resourceData]="rtoData"
  [selectedMonth]="month"
  [selectedYear]="year"
  (close)="closeAddExceptionModal()"
  (exceptionAdded)="onExceptionAdded($event)"
></app-add-exception>

<app-modal-wrapper [showModal]="showTeamDetailsModal">
  <app-team-composition-details
    *ngIf="showTeamDetailsModal"
    [empId]="selectedProfileId"
    (close)="closeTeamDetailsModal()"
  ></app-team-composition-details>
</app-modal-wrapper>
